<template>
    <div class="ssv-form">
        <div class="input-item">
            <label class="label" for="name">Jméno </label>
            <input class="input input--l" type="text" id="name" v-model="name">
            <ssv-order-error-field field="beneficiaryInformation.name"/>
        </div>

        <div class="input-item">
            <label class="label" for="surname">Přijmení</label>
            <input class="input input--l" type="text" id="surname" v-model="surname">
            <ssv-order-error-field field="beneficiaryInformation.surname"/>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {mapFields} from 'vuex-map-fields';
    import SsvOrderErrorField from '../error/ErrorField';

    export default {
        name: 'SsvOrderBeneficiaryInformationForm',
        components: {
            SsvOrderErrorField
        },
        computed: {
            ...mapFields('ssvOrder', [
                'beneficiaryInformation.name',
                'beneficiaryInformation.surname',
            ]),
        },
        methods: {
            ...mapActions('ssvOrder', ['setError']),
            validate() {
                if (!this.name || this.name.length === 0) this.setError({
                    msg: 'Zadejte jméno',
                    key: 'beneficiaryInformation.name'
                });
                if (!this.surname || this.surname.length === 0) this.setError({
                    msg: 'Zadejte přijmení',
                    key: 'beneficiaryInformation.surname'
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/beneficiary-information/BeneficiaryInformationForm.vue